import styled from "styled-components";

export const Input = styled.input`
    padding: 10px;
    font-size: 16px;
    border: 2px solid #ccc;
    border-radius: 5px;
    outline: none;
    transition: border-color 0.3s;
    &:focus {
        border-color: #007bff;
    }
`;

export const InputCheckboxElement = styled.input`
    display: none;
`

export const InputContainer = styled.div`
    display: block;
    align-items: center;
    max-width: 400px; 
`

export const ChartContainer = styled.div`
    width: 100%;
    margin: auto;
`

export const Label = styled.label`
    text-align: right;
    font-weight: bold;
    padding-right: 10px;
`

export const RowForm = styled.div`
    display: flex;
    padding-top: 10px;
`
export const OptionsForm = styled.div`
    //display: ${({ display_options }) => (display_options === 'true' ? 'block' : 'none')};
    display: none;
`
export const ParametersText = styled.div`
    border-top-style: solid;
    border-bottom-style: solid;
    padding-top: 10px;
    padding-bottom: 10px;
    border-color: #8d8d8d;
    font-weight: bold;
    text-align: center;
    margin-top: 15px;
    margin-bottom: 15px;
    width: 100%;
`

export const ContentContainer = styled.div`
    display: flex;
`

export const DefaultValueButton = styled.button`
    width: 100%;
    height: 40px;
    border-radius: 20px;
    border: none;
    background-color: #333;
    color: white;
    transition: 0.3s;

    &:hover {
        background-color: #565555;
    }
`

export const InputRadioButton = styled.input`
    //width: 100%;
`